import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import WordLearningGrid from 'components/WordLearningGrid';

export const WordGridModalComponent = ({ wordGridResource, defaultWord}) => {
    return <ExtendedContentContainer>
        <WordLearningGrid dataList={wordGridResource} defaultWord={defaultWord} />
    </ExtendedContentContainer>
};
